import { connect, ConnectedProps } from 'react-redux';
import {
  getWatcherTagsFromState,
  getSearchQueryParamsFromState,
} from '../../state/utils';
import { snakeToCamel } from '../../../caseUtils';
import { StateType } from '../../../state/state.types';
import { WatcherExistsType } from '../../state/reducers/watcherExists.types';
import { setWatcherExists } from '../../state/actions';

const mapState = ({ queryParams, results, watcherExists }: StateType) => {
  const clonedQueryParams = snakeToCamel(
    getSearchQueryParamsFromState(queryParams),
  );
  clonedQueryParams.q = results.query;
  return {
    tags: getWatcherTagsFromState(queryParams, results),
    queryParams: clonedQueryParams,
    watcherExists,
  };
};

const mapDispatch = (dispatch: Function) => ({
  updateWatcherExists(watcherExistsData: WatcherExistsType) {
    dispatch(setWatcherExists(watcherExistsData));
  },
});

export const Connect = connect(mapState, mapDispatch);
export type PropsFromRedux = ConnectedProps<typeof Connect>;
